export default __webpack_public_path__ + "static/media/login-img2.1a5ddd3b.png";